module.exports = function getResource(label, vars = []) {
    const resources = {
        estimatedTotalXItems: `Total estimé (${vars[0]} articles)`,
        estimatedTotal: 'Total estimé',
        shippingAndTaxes: 'Les frais d’expédition et les taxes seront calculés à la caisse.',
        bopisTaxes: 'Les taxes seront calculés à la caisse.',
        youSave: 'Vous économisez',
        sduSavingsUS: '6,95 $',
        sduSavingsCA: '9,95 $',
        withSDUUnlimited: 'avec la livraison le jour même illimitée',
        paymentLegal: 'Certains modes de paiement peuvent ne pas être disponibles pour certains articles ou certaines méthodes.',
        supportedPayment: 'Modes de paiement pris en charge'
    };

    return resources[label];
};
